/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_enter_letters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter at least two letters to find words.`)
};

const es_wu_enter_letters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce al menos dos letras para encontrar palabras.`)
};

const de_wu_enter_letters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib mindestens zwei Buchstaben ein, um Wörter zu finden.`)
};

const nl_wu_enter_letters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer minstens twee letters in om woorden te vinden.`)
};

const fr_wu_enter_letters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez au moins deux lettres pour trouver des mots.`)
};

const it_wu_enter_letters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci almeno due lettere per trovare le parole.`)
};

const pt_br2_wu_enter_letters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite pelo menos duas letras para encontrar palavras.`)
};

const pt_wu_enter_letters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza pelo menos duas letras para encontrar palavras.`)
};

const ja_wu_enter_letters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語を検索するには、2文字以上入力してください。`)
};

const zh_wu_enter_letters = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入至少两个字母以查找单词。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_enter_letters = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_enter_letters(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_enter_letters", locale)
	if (locale === "en") return en_wu_enter_letters(inputs)
	if (locale === "es") return es_wu_enter_letters(inputs)
	if (locale === "de") return de_wu_enter_letters(inputs)
	if (locale === "nl") return nl_wu_enter_letters(inputs)
	if (locale === "fr") return fr_wu_enter_letters(inputs)
	if (locale === "it") return it_wu_enter_letters(inputs)
	if (locale === "pt-BR") return pt_br2_wu_enter_letters(inputs)
	if (locale === "pt") return pt_wu_enter_letters(inputs)
	if (locale === "ja") return ja_wu_enter_letters(inputs)
	return zh_wu_enter_letters(inputs)
};